export default "__VITE_ASSET__BOeABwkC__"